import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { trackByValue } from '@y42/angular/util';
import { CsvOptions } from '@y42/json-schema';
import { FormControlsOf } from '@y42/angular/forms';
import { DatasourceTableSettingsCsvOptionsPropertyName, DatasourceTableSettingsNavigationsConstant } from '../../model';
import { FieldDelimiterTypes } from './csv-options.model';

@Component({
  selector: 'y42-csv-settings[form]',
  templateUrl: './csv-settings.component.html',
  styleUrls: ['./csv-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsvSettingsComponent {
  readonly trackByValue = trackByValue;
  readonly csvOptionsPropertyNames: Record<keyof CsvOptions, keyof CsvOptions> = {
    field_delimiter: 'field_delimiter',
    skip_leading_rows: 'skip_leading_rows',
    encoding: 'encoding',
    null_marker: 'null_marker',
    quote: 'quote',
    ignore_unknown_values: 'ignore_unknown_values',
    allow_quoted_new_lines: 'allow_quoted_new_lines',
    max_bad_records: 'max_bad_records',
  };

  @Input() form!: FormGroup<FormControlsOf<CsvOptions>>;
  fieldDelimiterTypes = FieldDelimiterTypes;
  navigationType = DatasourceTableSettingsNavigationsConstant[DatasourceTableSettingsCsvOptionsPropertyName];
}
